<template>
	<section class="crowdfunding-scale">
		<div class="container">
			<div class="content">
				<!-- LEFT: image -->
				<div class="left">
					<img
						class="map-image"
						:src="leftImage"
						:alt="leftImageAlt"
						loading="lazy"
					/>
				</div>

				<!-- RIGHT: text -->
				<div class="right">
					<h2 class="title headline-l">
						{{ $t('crowdxScreen.crowdfundingScale.title') }}
					</h2>

					<div class="subtitle text-l">
						{{ $t('crowdxScreen.crowdfundingScale.subtitle') }}
					</div>

					<div
						class="lead text-l bold"
						v-html="$t('crowdxScreen.crowdfundingScale.lead')"
					></div>

					<ul class="bullet-list text-l">
						<li v-for="(item, idx) in bulletItems" :key="idx">
							<span v-html="item"></span>
						</li>
					</ul>

					<div
						class="closing text-l bold"
						v-html="$t('crowdxScreen.crowdfundingScale.closing')"
					></div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: 'CrowdFundingAtScaleSection',
	props: {
		leftImage: {
			type: String,
			required: false,
			default: '/images/sections/crowdx/eu-map.png',
		},
		leftImageAlt: {
			type: String,
			required: false,
			default: 'Europe map',
		},

		bulletItems: {
			type: Array,
			required: false,
			default: () => [
				'The EU crowdfunding market is growing at an estimated <b>11.26% CAGR</b>, driven by digital adoption and regulatory clarity.',
				'The global market is projected to reach <b>$42.9 billion by 2032</b>, highlighting strong long-term growth.',
				'The EU serviceable market is expected to expand to <b>$12.9 billion</b> with an obtainable share of <b>$1.29 billion</b>.',
			],
		},
	},
};
</script>

<style lang="scss">
.crowdfunding-scale {
	position: relative;
	background: #ffffff;
	padding-top: 80px;
	padding-bottom: 50px;

	@media (max-width: $breakpoint-lg) {
		padding: 60px 0;
	}

	@media (max-width: $breakpoint-sm) {
		padding: 50px 0;
	}

	.content {
		display: flex;
		align-items: center;
		gap: 50px;

		@media (max-width: $breakpoint-lg) {
			gap: 40px;
		}

		@media (max-width: $breakpoint-md) {
			flex-direction: column;
			align-items: stretch;
			gap: 35px;
		}
	}

	.left {
		flex: 0 0 40%;
		display: flex;
		align-items: center;
		justify-content: center;
		min-width: 0;

		@media (max-width: $breakpoint-md) {
			flex: 1 1 auto;
		}
	}

	.map-image {
		width: 100%;
		height: auto;
		max-width: 551px;
		display: block;
		object-fit: contain;
		opacity: 0.5;
	}

	.right {
		flex: 1 1 60%;
		min-width: 0;
		color: #050535;

		@media (max-width: $breakpoint-md) {
			text-align: left;
		}
	}

	.title {
		margin: 0 0 18px 0;
		text-transform: uppercase;
		letter-spacing: 0.2px;
		font-size: 38px;
	}

	.subtitle {
		margin-bottom: 24px;
		color: #050535;
	}

	.lead {
		margin-bottom: 24px;
		max-width: 635px;
		line-height: 24px;
		color: #050535;
	}

	.bullet-list {
		margin: 0 0 26px 0;
		padding-left: 22px;
		max-width: 680px;

		li {
			margin: 2px 0;
			line-height: 24px;
			color: #050535;

			b {
				font-family: 'HKNova-Bold', sans-serif;
			}
		}
	}

	.closing {
		max-width: 680px;
		line-height: 24px;
		color: #050535;
	}
}

.bold {
	font-family: 'HKNova-Bold', sans-serif;
	font-weight: bold;
}
</style>
